import { z } from 'zod';

/**
 * 수신거부 응답.
 *
 * 어느 주소가 해지됐는지 돌려준다 — 화면이 그 주소를 보여줘야 「내가 맞게 눌렀나」를
 * 확인할 수 있다. 다만 **전체 주소를 그대로 내보내지 않는다.** 이 화면은 로그인 없이
 * 열리므로, 링크만 주우면 남의 메일 주소를 알아낼 수 있게 된다.
 */
export const unsubscribeResultSchema = z.object({
  /** 가운데를 가린 주소. 예: `na**@example.com` */
  maskedEmail: z.string().min(1),
});

export type UnsubscribeResult = z.infer<typeof unsubscribeResultSchema>;

/** 주소의 앞 두 글자만 남긴다. 로그인 없이 보는 화면이라 전체를 보여줄 수 없다. */
export function maskEmail(email: string): string {
  const [local = '', domain = ''] = email.split('@');
  const head = local.slice(0, 2);
  return `${head}${'*'.repeat(Math.max(local.length - head.length, 1))}@${domain}`;
}
